import { getDevicesState } from './devices-state';
export const isModalDisableCameraOpen = (state) => getDevicesState(state).isModalDisableCameraOpen;
